import { render, staticRenderFns } from "./Order3DModelCheck.vue?vue&type=template&id=522874fe"
import script from "./Order3DModelCheck.vue?vue&type=script&lang=js"
export * from "./Order3DModelCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports